import PropTypes from "prop-types";

import { Chip, Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { formatMoney, formatNumber } from "@/features/shared";
import { DiscountTypeEnum, discountTypeLabels } from "../enums/discount-type-enum";
import { promotionTypeLabels } from "../enums/promotion-type-enum";
import { promotionStatusColors } from "../status/status-colors";
import { promotionStatusLabels } from "../status/status-labels";

const GeneralInformationSection = ({ promotion }) => {
  const formattedDiscount =
    promotion.discountType === DiscountTypeEnum.PERCENTAGE
      ? `${formatNumber(promotion.discountAmount)}%`
      : formatMoney(promotion.discountAmount);

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Informasi Umum
      </Typography>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Nama Promosi
          </Typography>
          <Typography variant="body1">{promotion.name}</Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Kampanye Promosi
          </Typography>
          <Typography variant="body1">
            {promotion.promotionCampaign?.name}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Tipe Promosi
          </Typography>
          <Typography variant="body1">
            {promotionTypeLabels[promotion.promotionType]}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Status
          </Typography>
          <Chip
            label={promotionStatusLabels[promotion.status]}
            color={promotionStatusColors[promotion.status]}
            size="small"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Diskon ({discountTypeLabels[promotion.discountType]})
          </Typography>
          <Typography variant="body1">{formattedDiscount}</Typography>
        </Grid>
        {promotion.discountType === DiscountTypeEnum.PERCENTAGE && (
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="body2" color="text.secondary">
              Maksimal Diskon
            </Typography>
            <Typography variant="body1">
              {promotion.maximumDiscountAmount != null
                ? formatMoney(promotion.maximumDiscountAmount)
                : "-"}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  promotion: PropTypes.object.isRequired,
};

export default GeneralInformationSection;
